import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Only initialize Supabase if environment variables are provided
// This allows the app to run without backend configuration
let supabase = null;

// Debug logging
console.log('🔍 Supabase Config Check:');
console.log('  REACT_APP_SUPABASE_URL:', supabaseUrl ? '✅ Set' : '❌ Missing');
console.log('  REACT_APP_SUPABASE_ANON_KEY:', supabaseAnonKey ? '✅ Set' : '❌ Missing');

if (supabaseUrl && supabaseAnonKey) {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey);
    console.log('✅ Supabase client initialized successfully');
    console.log('   URL:', supabaseUrl);
  } catch (error) {
    console.error('❌ Error initializing Supabase:', error);
  }
} else {
  console.warn('⚠️ Supabase not configured - running in local-only mode');
  console.warn('To enable backend features, create a .env.local file with:');
  console.warn('  REACT_APP_SUPABASE_URL=your-url');
  console.warn('  REACT_APP_SUPABASE_ANON_KEY=your-key');
}

export { supabase };
